/**
 * claimApi — W1.7
 *
 * Typed API-Calls fuer den Token-Claim-Flow:
 * - POST /api/v2/auth/reauth       → ReauthResponse
 * - POST /api/v2/wallets/:id/claim → ClaimStartResponse
 * - GET  /api/v2/claims/:id        → ClaimStatusResponse
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const client = () => import('../../../lib/api-client').then((m) => m.default as any)

export type ReauthResponse = {
  reauth_token: string
  expires_in: number
}

export type ClaimStartResponse = {
  claim_id: string
}

export type ClaimStatus = 'pending' | 'submitted' | 'confirmed' | 'failed'

export type ClaimStatusResponse = {
  status: ClaimStatus
  tx_signature?: string
  failure_reason?: string
}

async function reauth(
  password: string,
): Promise<{ data?: ReauthResponse; error?: { status: number } }> {
  const api = await client()
  return api.POST('/api/v2/auth/reauth', {
    body: { password },
  })
}

async function startClaim(
  walletId: string,
  reauthToken: string,
  amount: number,
  tokenType: string,
): Promise<{ data?: ClaimStartResponse; error?: { status: number } }> {
  const api = await client()
  return api.POST('/api/v2/wallets/{id}/claim', {
    params: { path: { id: walletId } },
    headers: { 'X-Reauth-Token': reauthToken },
    body: { amount, token_type: tokenType },
  })
}

async function getStatus(
  claimId: string,
): Promise<{ data?: ClaimStatusResponse; error?: { status: number } }> {
  const api = await client()
  return api.GET('/api/v2/claims/{id}', {
    params: { path: { id: claimId } },
  })
}

export const claimApi = { reauth, startClaim, getStatus }
